// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"90fb52d8","767":"26384f47"}[chunkId] + ".chunk.js";
};